import { gql } from "apollo-boost";

export const GET_SETTING_BY_SHOP = gql`
query SettingByShopId($where: SettingWhereInput) {
  settingByShopId(where: $where) {
    id
    pointRate
    loyaltyEnable
    taxes {
      isVatIncluded
      taxStatus
      tax
      taxType
    }
    stockInOut
    commissionEnable
    shippingCost
    splitAmountOrder
    printBillA4
    editPriceBeforeSale
    editOrderAfterSale
  }
}
  ` 
export const GET_SETTING_BY_SHOP_V2 = gql`
query SettingByShopIdV2($where: SettingWhereInput) {
  settingByShopIdV2(where: $where) {
    id
    pointRate
    loyaltyEnable
    taxes {
      taxStatus
      tax
      taxType
    }
    stockInOut
    commissionEnable
    shippingCost
    splitAmountOrder
    printBillA4
    editPriceBeforeSale
    editOrderAfterSale
  }
}
  ` 

export const SHOP_SIZES = gql`
query ShopSizes($shop: String!) {
  shopSizes(shop: $shop) {
    id
    value
  }
}
`
